import { render, staticRenderFns } from "./ImportButton.vue?vue&type=template&id=eca83542&scoped=true"
import script from "./ImportButton.vue?vue&type=script&lang=ts"
export * from "./ImportButton.vue?vue&type=script&lang=ts"
import style0 from "./ImportButton.vue?vue&type=style&index=0&id=eca83542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca83542",
  null
  
)

export default component.exports